import { TUserMessType } from '../components/Chat/components/Message';
import { TPrivateMessage } from '../store/privateChat/types';
import { TMessage } from '../store/sockets/types';

export const checkUserType = (mess: TMessage | TPrivateMessage, userId?: string) => {
  let type: TUserMessType = 'user';
  if (mess?.typeId === 2) {
    type = 'admin';
    //@ts-ignore
  } else if (userId === mess?.userId || (mess?.userId1 && userId === mess?.userId1)) {
    type = 'my';
  } else if (mess?.typeId === 1) {
    type = 'lector';
  }
  return type;
};
